module.exports = __webpack_public_path__ + "static/img/5.39d6d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/5.png
// module id = KB+N
// module chunks = 35